// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"4954d1cc851244b9","5285":"e6046d42c7d7984e"}[chunkId] + ".css";
};